import { LintMood } from "./LintMood";

export function Problem() {
  return (
    <section className="border-t border-border bg-surface-elevated py-20 sm:py-28" data-testid="problem">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-[1.2fr_0.8fr]">
        <div>
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-navy sm:text-5xl">
            AI made building easier.
            <br />
            <span className="text-ink-muted">
              It didn&apos;t make knowing what you&apos;re building easier.
            </span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-ink-muted sm:text-lg">
            The late nights wondering if it will hold. The quiet fear that
            something underneath is wrong. That weight was never yours to carry
            alone.
          </p>
        </div>
        <LintMood
          from="sideEye"
          to="nod"
          alt="Lint, calm and reassuring"
          dark
          say={["Hmm. Shipped it without asking why?", "Breathe. I'll read what was built and tell you what matters."]}
          bubbleClass="max-w-xs text-base"
          className="w-56 sm:w-64"
          testId="problem-lint"
        />
      </div>
    </section>
  );
}
